import React from "react";
import "./Pane.css";

export const Pane = ({ children }) => <div className="pane">{children}</div>;
